/**
 * ============================================================================
 * useUnivoCarousel
 * ============================================================================
 *
 * Purpose: Imperative next/prev helpers with stable callbacks (INP-friendly).
 * ============================================================================
 */

"use client";

import { useCallback, useRef } from "react";
import type { UnivoCarouselHandle } from "./types";

export function useUnivoCarousel() {
  const ref = useRef<UnivoCarouselHandle | null>(null);

  const next = useCallback(() => {
    ref.current?.nextSlide();
  }, []);

  const prev = useCallback(() => {
    ref.current?.prevSlide();
  }, []);

  const startAutoplay = useCallback(() => {
    ref.current?.startAutoplay?.();
  }, []);

  const stopAutoplay = useCallback(() => {
    ref.current?.stopAutoplay?.();
  }, []);

  return {
    ref,
    next,
    prev,
    startAutoplay,
    stopAutoplay,
  };
}
